/* eslint react-hooks/exhaustive-deps: "warn" */

import { useContext, useMemo } from 'react';

import Head from 'next/head';

import { blog as blogTypes } from 'types';

import { useRouter } from 'libs/router/useRouter';
import { withDomainSuffix } from 'libs/seo';

import { ContentContext } from 'context/ContentContext';

import { useInt } from 'hooks/useInt';

import { Section } from 'ui/molecules/Section/Section';
import { Tabs } from 'ui/atoms/Tabs/Tabs';

import { ArticleSearch } from 'features/articles/organisms/ArticleSearch/ArticleSearch';
import { Benefits } from 'features/articles/organisms/Benefits/Benefits';

import styles from './BlogPage.module.scss';

const BlogPage = () => {
  const { t } = useInt();

  const { query } = useRouter();
  const { secondaryNavigation, pageVars } = useContext(ContentContext);

  const commonPageVars = useMemo(() => pageVars.common || {}, [pageVars.common]);

  const blog = useMemo(() => blogTypes.filter((type) => commonPageVars[`blog_${type}`]), [commonPageVars]);

  const blogSlug = secondaryNavigation?.blog?.slug || 'blog';

  const tabs = useMemo(
    () => [
      ...(commonPageVars.blog_all ? [{ key: '', label: commonPageVars.blog_all, route: blogSlug }] : []),
      ...blog.map((type) => ({ key: type, label: commonPageVars[`blog_${type}`], route: blogSlug, query: { type } })),
    ],
    [blog, commonPageVars, blogSlug],
  );

  const activeKey = useMemo(() => `${query.type || ''}`, [query.type]);

  const isRegistryGuides = activeKey === 'company_registry_guides';

  const categoryLabel = activeKey ? commonPageVars[`blog_${activeKey}`] : '';

  const categoryDescription = categoryLabel
    ? t('Articles and guides on {category} from Global Database.').replace('{category}', categoryLabel)
    : '';

  return (
    <Section title={isRegistryGuides ? 'Company Registry Guides' : commonPageVars.blog_title}>
      {categoryLabel && (
        <Head>
          <title key="title">{withDomainSuffix(categoryLabel)}</title>
          <meta key="og:title" property="og:title" content={withDomainSuffix(categoryLabel)} />
          <meta key="description" name="description" content={categoryDescription} />
          <meta key="og:description" property="og:description" content={categoryDescription} />
        </Head>
      )}

      <div className={styles.blogHeaderNav}>
        <ArticleSearch variant="pill" className={styles.blogSearch} />

        {!isRegistryGuides && <Tabs tabs={tabs} activeKey={activeKey} size="xl" variant="underline" scrollable />}
      </div>

      <Benefits hasPriortyFirstImage className={styles.blogPageBenefits} withBlog />
    </Section>
  );
};

// eslint-disable-next-line import/no-default-export
export default BlogPage;
